<template>
  <div class="template-dashboard">
    <error-global ref="ErrorGlobal"></error-global>
    <nav class="navbar navbar-dark fixed-top" id="navbar-top" v-bind:class="{'navbar__scrolled': navbarScrolled}">
      <button class="navbar-toggler" @click.prevent="navbarShow = !navbarShow" type="button" aria-controls="navbar-main" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-i"><i></i><i></i><i></i></span>
      </button>
      <div class="collapse navbar-collapse" v-bind:class="{show: navbarShow}" id="navbar-main">
        <ul class="navbar-nav mr-auto">
          <li class="nav-item active"><router-link class="nav-link" :to="{name: 'account'}">My Account</router-link></li>
          <li class="nav-item"><router-link class="nav-link" :to="{name: 'logout'}">Logout</router-link></li>
        </ul>
      </div>
      <div class="navbar__contact">
        <router-link :to="{name: 'contact'}"><i class="far fa-comment-dots"></i></router-link>
        <a :href="'tel:' + business.phone"><i class="fas fa-phone-alt navbar__contact__phone"></i></a>
      </div>
    </nav>

    <div class="hero">
      <div class="container">
        <div class="hero__container">
          <h1 class="hero__title" v-if="customer">
            Hi {{ customer.type_service == 1 ? customer.first_name : customer.company }}
          </h1>
          <div class="hero__phone">Welcome to {{ business.name }} account</div>
        </div>
        <img class="hero__logo" v-if="business.avatar.url_sm" :src="business.avatar.url_sm">
      </div>
    </div>

    <main role="main">
      <div class="container">
        <div class="row">
          <div class="col-lg-6 desktop">

            <div class="box">
              <ul class="menu">
                <li>
                  <router-link v-if="!widget_booking.page_url" :to="{name: 'request-service'}"><i class="far fa-clipboard"></i><span>Request Service</span></router-link>
                  <a v-if="widget_booking.page_url" :href="widget_booking.page_url" target="_blank"><i class="far fa-clipboard"></i><span>Request Service</span></a>
                </li>
                <li><router-link :to="{name: 'events'}"><i class="far fa-calendar-alt"></i><span>Appointments</span></router-link></li>
                <li><router-link :to="{name: 'invoices'}"><i class="far fa-file-alt"></i><span>Invoices</span></router-link></li>
                <li><router-link :to="{name: 'estimates'}"><i class="far fa-file"></i><span>Estimates</span></router-link></li>
                <li><router-link :to="{name: 'deals'}"><i class="far fa-money-bill-alt"></i><span>Deals</span></router-link></li>
                <li><router-link :to="{name: 'files'}"><i class="far fa-folder"></i><span>File Vault</span></router-link></li>
              </ul>
            </div>

          </div>
          <div class="col-lg-12">

            <app-update :app-version="appVersion"></app-update>

            <div class="box box__event">
                <div class="box__cnt">
                  <h3 class="box__title">Next Appointment</h3>
                  <div class="box__noevent" v-if="events_upcoming.length == 0">
                  No upcoming events
                  </div>
                  <div class="event" v-for="event in events_upcoming" :key="event.id" @click.prevent="viewEvent(event.id)">
                    <div class="event__name">
                      <span class="weight-medium">{{ event.name }}</span>
                    </div>
                    <div class="event__date">
                      {{ event.datetime_text_display_date }}<br>
                      {{ event.datetime_text_display_time }}
                    </div>
                  </div>
                  <router-link class="box__event-all" :to="{name: 'events'}">View all</router-link>
              </div>
              <div class="box__icon">
                  <i class="icon-ma-appointment"></i>
              </div>
            </div>

            <div class="box box__invoice">
              <div class="box__icon">
                <i class="icon-ma-invoice"></i>
              </div>
              <div class="box__cnt" @click.prevent="$router.push('invoices')">
                <h3 class="box__title">Invoices and Payments</h3>
                <div class="box__cnt--name">Total Due</div>
                <div class="box__cnt-value">{{ invoices_summary.total_due.total_text }}</div>
              </div>
              <div class="box__btn">
                <router-link class="btn btn-pay btn-sm" v-if="invoices_summary.total_due.count > 0"  :to="{name: 'invoices', query: {tab: 'due'} }">Pay Now</router-link>
              </div>
            </div>

            <div class="box box__estimate" @click.prevent="$router.push('estimates')">
                <div class="box__icon">
                    <i class="icon-ma-estimate"></i>
                </div>
                <div class="box__cnt">
                    <h3 class="box__title">Estimates</h3>
                    <div class="box__cnt-value">
                        {{ estimates_count }} <span class="box__cnt-value-sm">pending estimate{{ estimates_count | pluralize }}</span>
                    </div>
                </div>
            </div>

            <div class="box box__deal" v-if="deals.length > 0">
                <div class="box__cnt">
                    <h3 class="box__title">Deals</h3>
                    <div class="deal" v-for="deal in deals" :key="deal.id" @click="viewDeal(deal.url)">
                        <img class="deal__img" :src="deal.images[0].url_sm">
                        <div class="deal__cnt">
                            <div class="deal__title">{{ deal.title}}</div>
                            <div class="deal__description">{{ deal.description }}</div>
                        </div>
                    </div>
                </div>
                <div class="box__icon">
                    <i class="icon-ma-shop"></i>
                </div>
            </div>

            <div class="box box__file" @click.prevent="$router.push('files')">
                <div class="box__cnt">
                    <h3 class="box__title">Files Vault</h3>
                    <div class="box__cnt-value">
                        {{ files_count }} <span class="box__cnt-value-sm">file{{ files_count | pluralize }}</span>
                    </div>
                </div>
                <div class="box__icon">
                    <i class="icon-ma-expense"></i>
                </div>
            </div>

        </div>
        <div class="col-lg-6">

            <div class="box">
                <p>{{ customer_portal_config.about }} </p>
                <hr>
                <div class="margin-bottom">
                    <div class="weight-medium">Business Phone</div>
                    {{ business.phone | formatPhone }}
                </div>
                <div class="margin-bottom" v-if="business.is_emergency_support == 1">
                    <div class="weight-medium">24/7 Emergency</div>
                    {{ business.phone_emergency | formatPhone }}
                </div>
                <div class="margin-bottom" v-if="business.website">
                  <div class="weight-medium">Website</div>
                  <a class="business__website" :href="business.website" target="_blank">{{business.website}}</a>
                </div>
                <div class="weight-medium">{{ business.name }}</div>
                {{ business.address }}<br>
                {{ business.city }}, {{ business.state }}
            </div>

        </div>
    </div>

    </div>
    </main>

    <navbar-footer class="mobile" :request-service-url="widget_booking.page_url"></navbar-footer>

    </div>
</template>

<script>
import debounce from 'lodash/debounce';
import AppUpdate from '@/components/AppUpdate.vue';
import ErrorGlobal from '@/components/ErrorGlobal.vue';
import NavbarFooter from '@/components/NavbarFooter.vue';
import Http from '@/lib/http';

export default {
  name: 'dashboard',
  components: {
    AppUpdate,
    ErrorGlobal,
    NavbarFooter,
  },
  props: {},
  data() {
    return {
      business: {
        avatar: {
          url_sm: '',
        },
        phone: '',
      },
      customer: null,
      customer_portal_config: {
        about: '',
      },
      events_upcoming: [],
      invoices_summary: {
        total_due: {
          total_text: '',
        },
      },
      estimates_count: 0,
      files_count: 0,
      deals: [],
      widget_booking: {
        page_url: '',
      },

      handleDebouncedScroll: null,
      navbarScrolled: false,
      navbarShow: false,

      appVersion: 0,
    };
  },
  created() {
    this.handleDebouncedScroll = debounce(() => {
      if (window.pageYOffset > 100) {
        this.navbarScrolled = true;
      } else {
        this.navbarScrolled = false;
      }
    }, 50);
    window.addEventListener('scroll', this.handleDebouncedScroll);

    this.getDashboard();
  },
  methods: {
    getDashboard() {
      Http.get('dashboard/main', {
        slug: this.$route.params.slug,
      }).then((response) => {
        this.business = response.data.business;
        this.customer = response.data.customer;
        this.customer_portal_config = response.data.customer_portal_config;
        this.events_upcoming = response.data.events_upcoming;
        this.invoices_summary = response.data.invoices_summary;
        this.estimates_count = response.data.estimates_count;
        this.deals = response.data.deals;
        this.files_count = response.data.files_count;
        if (response.data.widget_booking) {
          this.widget_booking = response.data.widget_booking;
        }
        this.appVersion = response.data.config.app_version;

        // process
        this.events_upcoming.map((event) => {
          const row = event;
          const [dayofweek, date, time] = row.datetime_text_display.split(',');
          row.datetime_text_display_date = [dayofweek, date].join(', ');
          row.datetime_text_display_time = time;
          return row;
        });
      }).catch((error) => {
        if (error.response) {
          this.$refs.ErrorGlobal.show(error.response.data.error.message);
        }
      });
    },
    viewDeal(dealUrl) {
      // this.$router.push({ path: `deals/view/${dealId}` });
      window.location.href = dealUrl;
    },
    viewEvent(eventId) {
      this.$router.push({ path: `events/view/${eventId}` });
    },
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleDebouncedScroll);
  },
};
</script>

<style scoped>
.template-dashboard {
  padding-bottom: 70px;
}

/* navbar */
.navbar__contact {
  position: absolute;
  top: 20px;
  right: 10px;
  text-align: right;
}
.navbar__contact a {
  color: #fff;
  text-align: right;
  font-size: 18px;
  display: inline-block;
  margin-right: 20px;
  font-size: 22px;
}
.navbar__contact__phone {
  font-size: 20px;
}
.navbar__scrolled {
  background: #267edb;
}
.navbar-dark .navbar-toggler {
  color: #fff;
  border-style: none;
  padding: 5px 0;
}
.navbar-dark .navbar-toggler:focus {
  outline: none;
}
.navbar-dark .navbar-nav .nav-link {
  color: #fff;
}

.navbar-toggler-i {
  display: inline-block;
  width: 24px;
  height: 18px;
  line-height: 0px;
  margin: 6px 4px 0 10px;
}
.navbar-toggler-i i {
  display: inline-block;
  height: 2px;
  width: 100%;
  background: #fff;
  line-height: 0px;
  margin: 3px 0;
}

.navbar-nav {
  padding-left: 10px;

}
.navbar-collapse.show {
  background: #267edb;
  background-color: rgba(38, 126, 219, 0.75)
}

/* hero */
.hero {
  position: relative;
  background: url("../assets/dashboard_hero.png") #2d8ae1;
  min-height: 220px;
}
.hero .container {
  position: relative;
}
.hero__container {
  width: 100%;
  z-index: 200;
  text-align: center;
  padding-top: 60px;
  padding-bottom: 50px;
}
.hero__logo {
  position: absolute;
  left: 50%;
  bottom: -30px;
  margin-left: -26px;
  width: 54px;
  height: 54px;
  border: 2px solid #fff;
  border-radius: 50%;
  background: #e5eaea;
  margin-bottom: 10px;
  z-index: 210;
}
.hero__title {
  font-size: 1.4em;
  color: #fff;
  font-weight: normal;
  margin: 0;
  margin-bottom: 5px;
}
.hero__phone {
  color: #dbeaf9;
}

.avatar-container {
  position: relative;
  margin-top: 30px;
  margin-bottom: 20px;
}
.avatar {
  position: absolute;
  top: 0;
  left: 0;
  width: 42px;
  height: 42px;
  background: #eaeaea;
  text-align: center;
  border-radius: 50%;
}
.avatar i {
  margin-top: 12px;
  color: #aaa;
}
.avatar-cnt {
  padding-left: 60px;
  line-height: 1.2em;
}

.menu {
  list-style: none;
  margin: 0;
  padding: 0;
}
.menu li {
  padding: 10px 12px;
  border: none;
  border-radius: 20px;
  margin-bottom: 20px;
  background: #e3e9f1;
}
.menu li a {
  color: #6a717d;
  font-weight: 500;
  font-weight: normal;
}
.menu li a i {
  font-size: 22px;
  margin-right: 16px;
  color: #b5bdcc;
}
.menu li a .fa-margin-right {
  margin-right: 16px;
  color: #b5bdcc;
}

/* box */
.box {
  min-height: auto;
  margin-bottom: 20px;
  position: relative;
}
.box__icon {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 40px;
  text-align: right;
}
.box__icon i {
  font-size: 28px;
  color: #858585;
  margin-top: 22px;
}
.box__arrow {
  position: absolute;
  top: 50%;
  right: 10px;
  width: 30px;
  margin-top: -15px;
  border: 2px solid #60c386;
  border: 2px solid #eaeaea;
  width: 28px;
  height: 28px;
  border-radius: 50%;
}
.box__arrow i {
  color: #60c386;
  color: #eaeaea;
  font-size: 18px;
  margin-left: 7px;
}
.box__cnt {
  padding: 0 40px 0 0;
}
.box__cnt-value {
  font-size: 22px;
}
.box__cnt-value-sm {
  font-size: 16px;
}
.box__title {
  font-size: 14px;
  margin-bottom: 5px;
  color: #858585;
}

/* event */
.box__event {
  margin-top: -50px;
  padding-top: 30px;
}
.box__event .box__icon {
  top: 30px;
}
.box__event-all {
  position: absolute;
  bottom: 20px;
  right: 20px;
}
.box__noevent {
  padding: 20px 0 0 0;
}

.event {
  cursor: pointer;
}
.event__date {
  color: #858585;
}

/* invoice */
.box__invoice {
  background: linear-gradient(to right, #f7797d, #ffdf97);
  background: linear-gradient(to right, #f66469, #fdbf86);
  color: #fff;
}
.box__invoice h3 {
  color: #fff;
}
.box__invoice .box__icon i {
  color: #fff;
}
.box__invoice .box__cnt {
  cursor: pointer;
}

.btn-pay {
  position: absolute;
  bottom: 20px;
  right: 20px;
  color: #f05357;
  background: #fff;
  padding: 2px 12px;
}
.btn-pay:hover {
  color: #f05357;
  background: #feefe6;
}

/* other */
.box__estimate,
.box__file {
  cursor: pointer;
}

/* deal */
.box__deal .box__title {
  margin-bottom: 20px;
}
.deal {
  display: flex;
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #eaeaea;
  cursor: pointer;
}
.deal:last-child {
  border-bottom: none;
  margin-bottom: 0;
}
.deal__img {
  width: 70px;
  padding-right: 10px;
  padding-top: 3px;
  object-fit: contain;
  align-self: flex-start;
}
.deal__cnt {
  flex: 1 1 auto;
}
.deal__title {
  font-weight: 500;
  line-height: 20px;
  margin-bottom: 5px;
}
.deal__description {
  color: #858585;
  line-height: 1.2em;
}

/* business */
.business__website {
    overflow: hidden;
    display: block;
    white-space: nowrap;
    text-overflow: ellipsis;
}

@media (min-width: 992px) {
  .hero {
    margin-bottom: 20px;
  }

  .box {
    /* min-height: 650px; */
  }

  .box__event {
    margin-top: 0;
  }
}
</style>
